import {ReactElement, useState, useEffect} from 'react';
import {Adapter as AdapterType} from 'ui/adapters/types';
import {screenService, ScreenService, Orientation} from 'services/screen';

export interface ShowSummaryAdapterProps {
  children: (showSummary: boolean) => ReactElement;
}

interface Dependencies {
  service?: ScreenService;
}

export function createAdapter(di: Dependencies = {}): AdapterType<ShowSummaryAdapterProps> {
  const {service = screenService} = di;
  const canChangeOrientation = service.canChangeOrientation();
  const initialOrientation = service.orientationOf();

  return function Adapter({children}) {
    const [orientation, setOrientation] = useState<Orientation>(initialOrientation);

    useEffect(() => {
      const cleanup = service.onOrientationChange(setOrientation);
      return cleanup;
    }, [setOrientation]);

    const showSummary = canChangeOrientation && orientation === 'landscape';
    return children(showSummary);
  };
}

export const ShowSummary = createAdapter();
